var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmilingface = function SvgSmilingface(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 70.476c16.832 0 30.476-13.645 30.476-30.476S56.832 9.524 40 9.524C23.17 9.524 9.524 23.169 9.524 40S23.169 70.476 40 70.476Z",
    fill: "url(#smilingface_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 70.476c16.832 0 30.476-13.645 30.476-30.476S56.832 9.524 40 9.524C23.17 9.524 9.524 23.169 9.524 40S23.169 70.476 40 70.476Z",
    fill: "url(#smilingface_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 70.476c16.832 0 30.476-13.645 30.476-30.476S56.832 9.524 40 9.524C23.17 9.524 9.524 23.169 9.524 40S23.169 70.476 40 70.476Z",
    fill: "url(#smilingface_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 70.476c16.832 0 30.476-13.645 30.476-30.476S56.832 9.524 40 9.524C23.17 9.524 9.524 23.169 9.524 40S23.169 70.476 40 70.476Z",
    fill: "url(#smilingface_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.267c-8.781 0-11.581-9.41-8.914-7.943 3.58 1.98 5.866 2.171 8.914 2.171s5.314-.19 8.914-2.171c2.667-1.467-.133 7.943-8.914 7.943Z",
    fill: "#643800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.914 52.324c-3.58 1.98-5.866 2.171-8.914 2.171-3.047 0-5.314-.19-8.914-2.171-.933-.514-1.2.285-.781 1.562 0-.02.133-1.39 1.39-.438 0 0 4.629 2.78 8.286 2.78s8.286-2.78 8.286-2.78c1.257-.934 1.39.419 1.39.438.457-1.277.19-2.077-.743-1.562Z",
    fill: "url(#smilingface_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.352 28.876c.172-1.219-1.047-2.152-3.295-2.438-1.923-.267-6.247.229-9.657 3.562-.628.61.152 1.105.724.724 1.98-1.276 7.01-2.572 10.667-1.676 1.485.38 1.561-.172 1.561-.172Z",
    fill: "url(#smilingface_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.648 28.876c-.172-1.219 1.047-2.152 3.295-2.438 1.924-.248 6.248.229 9.657 3.562.629.61-.152 1.105-.724.724-1.98-1.276-7.01-2.572-10.666-1.677-1.486.381-1.562-.17-1.562-.17Z",
    fill: "url(#smilingface_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.629 36.304s5.028.877 6.152 4.8c.076.248.095.515.076.762-.038.515-.552 1.01-1.41.458-5.333-3.448-8.628-2.248-11.085-1.41-.952.324-1.714-.686-1.371-1.486.095-.228.171-.476.323-.685 2.286-3.334 7.315-2.439 7.315-2.439Z",
    fill: "url(#smilingface_svg__h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.42 37.505s4.094.704 6.418 4.057a3.805 3.805 0 0 0-.076-.457c-1.124-3.924-6.152-4.8-6.152-4.8s-5.01-.896-7.334 2.419a2.016 2.016 0 0 0-.21.4c3.277-2.362 7.353-1.62 7.353-1.62Z",
    fill: "url(#smilingface_svg__i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.371 36.304s-5.028.877-6.152 4.8c-.076.248-.095.515-.076.762.038.515.552 1.01 1.41.458 5.333-3.448 8.628-2.248 11.085-1.41.953.324 1.714-.686 1.372-1.486-.096-.228-.172-.476-.324-.685-2.286-3.334-7.315-2.439-7.315-2.439Z",
    fill: "url(#smilingface_svg__j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.58 37.505s-4.094.704-6.418 4.057c.019-.153.038-.305.076-.457 1.124-3.924 6.152-4.8 6.152-4.8s5.01-.896 7.334 2.419c.095.133.152.266.21.4-3.277-2.362-7.353-1.62-7.353-1.62Z",
    fill: "url(#smilingface_svg__k)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.004 27.649) scale(36.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.004 27.649) scale(28.9251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.80402 -.61957 .49023 10.13115 23.396 47.582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FB4C0B",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EF4B27",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-177.23 28.873 23.107) scale(12.819 10.143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FB4C0B",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EF4B27",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.39422 .94928 -.45802 2.60267 52.136 39.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smilingface_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(170.019 12.267 20.742) scale(5.47711 2.64266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smilingface_svg__e",
    x1: 40,
    y1: 48.849,
    x2: 40,
    y2: 56.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smilingface_svg__f",
    x1: 26.709,
    y1: 30.051,
    x2: 27.136,
    y2: 26.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smilingface_svg__g",
    x1: 53.291,
    y1: 30.051,
    x2: 52.864,
    y2: 26.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smilingface_svg__i",
    x1: 52.929,
    y1: 34.722,
    x2: 52.335,
    y2: 38.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smilingface_svg__k",
    x1: 27.021,
    y1: 34.693,
    x2: 27.614,
    y2: 38.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
};

export default SvgSmilingface;